import React, { useState } from "react";
import { Routes, Route } from "react-router-dom";
import MainLayout from "../layout/MainLayout";
import Home from "../../pages/Home";
import ProjectFilters from "../filters/ProjectFilters";
import AdvancedFilters from "../filters/AdvanceFilters";
import ProjectsList from "../../pages/ProjectsList";
import Header from "../layout/Header";
import ProjectsGrid from "../../pages/projectsGrid";
import TechnicalScope from "../../pages/TechnicalScope";
import PlanningStrategy from "../../pages/PlanningStrategy";
import EngineeringScope from "../../pages/EngineeringScope";
import BCInformation from "../../pages/BcInformation";
import ProjectInfo from "../../pages/ProjectInformation";
import ProjectInformationView from "../../pages/view/ProjectInformationView";
import ChangeHistory from "../../pages/ChangeHistory";

import NotFound from "../../pages/NotFound";
import Milestone from "../../pages/Milestone";
import Logistics from "../../pages/Logistics";
import KpiSummary from "../../pages/KpiSummary";
import SEOSustainability from "../../pages/SEOSustainability";
import Procurement from "../../pages/Procurement";
import InnoflexPhasePage from "../../pages/InnoflexPhaseHelpPage";
import DeletedProjectsList from "../../pages/deletedProjectsList";
import CMOInnovationForum from "../../pages/CMOInnovationForum";
import { useFilters } from "../../../hooks/context/FiltersContext";

const AppRoutes: React.FC = () => {
  const [selectedFilter, setSelectedFilter] = useState<string>("all");
  const [viewType, setViewType] = useState<string>("grid");
  // const [filters, setFilters] = useState<Partial<AdvancedFilters>>({});
  const { filters, setFilters } = useFilters();

  return (
    <Routes>
      {/* Pages without layout */}
      <Route path="/" element={<Home />} />
      <Route
        path="/project"
        element={
          <>
            <Header />
            <ProjectFilters
              selectedFilter={selectedFilter}
              onFilterChange={setSelectedFilter}
              viewType={viewType}
              onViewChange={setViewType}
            />
            <AdvancedFilters
              onFilterChange={setFilters}
              initialFilters={filters}
            />
            <ProjectsList selectedFilter={selectedFilter} filters={filters} />
          </>
        }
      />
      <Route
        path="/projects-grid"
        element={
          <>
            <Header />
            <ProjectFilters
              selectedFilter={selectedFilter}
              onFilterChange={setSelectedFilter}
              viewType={viewType}
              onViewChange={setViewType}
            />
            <AdvancedFilters
              onFilterChange={setFilters}
              initialFilters={filters}
            />
            <ProjectsGrid selectedFilter={selectedFilter} filters={filters} />
          </>
        }
      />
      <Route
        path="/innoflex-phase"
        element={
          <>
            <Header />
            <InnoflexPhasePage />
          </>
        }
      />
      <Route
        path="/deleted-projects"
        element={
          <>
            <Header />
            <DeletedProjectsList />
          </>
        }
      />
      <Route path="/" element={<MainLayout />}>
        <Route path="/create-project" element={<ProjectInfo />} />
        <Route
          path="/project/project-info/:projectId/:projectKey"
          element={<ProjectInformationView />}
        />
        <Route
          path="/project/project-info/history/:projectId/:projectKey"
          element={<ChangeHistory />}
        />
        <Route
          path="/project/project-info/:projectId/view"
          element={<ProjectInformationView />}
        />
        <Route
          path="/project/milestones/:projectId/:projectKey"
          element={<Milestone />}
        />
        <Route
          path="/project/procurement/:projectId/:projectKey"
          element={<Procurement />}
        />
        <Route
          path="/project/bc-information/:projectId/:projectKey"
          element={<BCInformation />}
        />
        <Route
          path="/project/technical-scope/:projectId/:projectKey"
          element={<TechnicalScope />}
        />
        <Route
          path="/project/planning-strategy/:projectId/:projectKey"
          element={<PlanningStrategy />}
        />
        <Route
          path="/project/engineering-scope/:projectId/:projectKey"
          element={<EngineeringScope />}
        />
        <Route
          path="/project/logistics/:projectId/:projectKey"
          element={<Logistics />}
        />
        <Route
          path="/project/sheq-sustainability/:projectId/:projectKey"
          element={<SEOSustainability />}
        />
        <Route
          path="/project/kpi-summary/:projectId/:projectKey"
          element={<KpiSummary />}
        />
        <Route
          path="/project/cmoinnovationforum/:projectId/:projectKey"
          element={<CMOInnovationForum />}
        />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;
